var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg002(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 87,
    viewBox: "0 0 86 87",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 43,
    cy: 43.5,
    r: 43,
    fill: "#E7FFD8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.2118 38.9709C53.7243 32.4259 48.0151 29.4792 43.0001 29.4792C43.0001 29.4792 43.0001 29.4792 42.986 29.4792C37.9851 29.4792 32.2618 32.4117 30.7743 38.9567C29.1168 46.2667 33.5935 52.4576 37.6451 56.3534C39.1468 57.7984 41.0735 58.5209 43.0001 58.5209C44.9268 58.5209 46.8535 57.7984 48.341 56.3534C52.3926 52.4576 56.8693 46.2809 55.2118 38.9709ZM43.0001 46.0684C40.5351 46.0684 38.5376 44.0709 38.5376 41.6059C38.5376 39.1409 40.5351 37.1434 43.0001 37.1434C45.4651 37.1434 47.4626 39.1409 47.4626 41.6059C47.4626 44.0709 45.4651 46.0684 43.0001 46.0684Z",
    fill: "#559D5C"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg002);
export default __webpack_public_path__ + "static/media/002.00b5a9a24cda68527ad55eb34c1b81ba.svg";
export { ForwardRef as ReactComponent };